<template>
  <div class="verify-token-container">
    <div v-if="isLoading" class="verify-token-loading">
      <!-- Puedes agregar un spinner o mensaje de carga aquí -->
      <p>{{ t('verify-token.loading') }}</p>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed, onBeforeMount, ref } from 'vue'
import store from '@/store'
import router from '@/router'
import swal from '@/utils/sweetalertUtil'
import { useI18n } from 'vue-i18n'

/* eslint-disable */
/* tslint:disable */

defineOptions({
  name: "VerifyTokenView",
});

const { t } = useI18n()
const route = useRoute()
const isLoading = ref(true)
const expires_in = computed(() => route.params.expires_in)
const redirect_route_name = computed(() => route.params.redirect_route_name)
const redirect_params_base64 = computed(() => route.params.redirect_params_base64)

const redirectToLogin = () => {
  const resilienciaDomain = process.env.VUE_APP_RESILIENCIA_DOMAIN
  if (resilienciaDomain) {
    window.location.href = `${resilienciaDomain}/login`
  }
}

onBeforeMount(async () => {
  if (!expires_in.value) {
    isLoading.value = false
    await swal.fire({
      icon: 'error',
      title: t('alert-title-message'),
      text: t('verify-token.errors.missingParams'),
      confirmButtonText: t("back"),
    })
    redirectToLogin()
    return
  }

  try {
    const { data, error, message } = await store.dispatch('auth/verifyToken', {
      expires_in: expires_in.value
    })

    if (!error && data) {

      // Con cookies: solo user y expires_in (token no se guarda en cliente)
      if (!data.user || !data.user.route_name_redirect?.route_name) {
        throw new Error('Invalid response structure')
      }

      store.commit('auth/login', {
        user: data.user,
        expires_in: data.expires_in ?? expires_in.value
      })
      await store.dispatch('auth/fetchClinicalNotesCryptoStatusIfPsychologist')

      // Intentar redirigir, con manejo de error si la ruta no existe
      try {
        if (redirect_route_name.value) {
          let paramsToUse = {}

          // Si redirect_params existe, decodificarlo desde base64
          if (redirect_params_base64.value) {
            try {
              const decoded = JSON.parse(atob(decodeURIComponent(redirect_params_base64.value)))
              paramsToUse = decoded
            } catch (e) {
              console.warn('Error decodificando redirect_params:', e)
              // Si falla la decodificación, usar objeto vacío
              paramsToUse = {}
            }
          }

          await router.push({
            name: redirect_route_name.value,
            params: paramsToUse
          })

        } else {
          await router.push({ name: data.user.route_name_redirect.route_name })
        }
      } catch (routerError) {
        // Si la ruta no existe, redirigir a login
        console.error('Route not found:', data.user.route_name_redirect.route_name, routerError)
        await swal.fire({
          icon: 'error',
          title: t('alert-title-message'),
          text: t('verify-token.errors.invalidRoute'),
          confirmButtonText: t("back"),
        })
        redirectToLogin()
      }
    } else {
      // Error en la verificación del token
      await swal.fire({
        icon: 'error',
        title: t('alert-title-message'),
        text: message || t('verify-token.errors.verificationFailed'),
        confirmButtonText: t("back"),
      })
      redirectToLogin()
    }
  } catch (error) {
    // Error inesperado
    console.error('Error verifying token:', error)
    await swal.fire({
      icon: 'error',
      title: t('alert-title-message'),
      text: t('verify-token.errors.unexpected'),
      confirmButtonText: t("back"),
    })
    redirectToLogin()
  } finally {
    isLoading.value = false
  }
})

</script>

<style scoped lang="scss">
.verify-token-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.verify-token-loading {
  text-align: center;
}
</style>
